import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./CareerDetails.css";
export default class CareerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "application",
      resume: null,
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      coverLetter: "",
      expectedSalary: "",
      agree: false,
    };
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  renderContent() {
    const { activeTab } = this.state;
    if (activeTab === "overview") {
      return (
        <div>
          <div className="w-75">
            <p className="my-4">
              We are on the lookout for talented, curious, and collaborative
              individuals who are willing to take up new tasks and build great
              tech. Together with the team, you will work on complex,
              innovative, and exciting projects.
            </p>
            <div className="mb-5">
              <h5>Responsibilities</h5>
              <ul>
                <li>
                  Understanding and Preparing dynamic digital marketing
                  strategies.
                </li>
                <li>
                  Creativity to carryout marketing campaigns and up to date
                  knowledge in digital marketing.
                </li>
                <li>
                  Create engaging contents for all digital media platforms.
                </li>
                <li>
                  Setup, manage and optimize Google Adwards and social media
                  campaigns.
                </li>
                <li>Making detailed evaluation and reports of campaigns.</li>
              </ul>
            </div>
            <h5>Qualifications & Requirements</h5>
            <ul>
              <li>
                2+ years experience in handling digital marketing campaigns.
              </li>
              <li>
                A Relevant Degree / Diploma in Digital Marketing / Design /
                Communication & Marketing
              </li>
              <li>
                Strong understanding about PPC, SEO strategies and experience in
                paid social media campaigns
              </li>
              <li>Strong communication skills in English</li>
              <li>
                Experience in IT-related campaign management and skills in
                motion design will be an added advantage.
              </li>
            </ul>
          </div>
          <div className="pt-5 mb-4">
            If you meet the requirements above, <br />
            We are looking for YOU!
          </div>
          <div className="mt-4">
            <button className="primary-btn fw-500">Apply Now {">"}</button>
          </div>
          <div className="container text-center">
            <div className="hero-text fw-700 my-5">
              LET’S{" "}
              <span className="hero-text-gradient">TRANSFORM THE FUTURE</span>{" "}
              <br />
              TOGETHER
            </div>
            <p>Book a free consultation{">"}</p>
          </div>
        </div>
      );
    } else if (activeTab === "application") {
      return (
        <div className="form-container">
          <h2>Apply For this Job</h2>
          <form onSubmit={this.handleSubmit} className="job-form">
            <label>
              Resume/CV<span className="required">*</span>
            </label>
            <div className="file-upload-box p-5 d-flex flex-column  align-items-center">
              <input
                type="file"
                accept="application/pdf"
                onChange={this.handleFileChange}
              />
              <div className="w-50">
                <img src="./assets/icons/upload.gif" className="w-25 text-center" alt="" />
              </div>

              <p>Click or drag file to this area to upload your Resume</p>
              <small>Please make sure to upload a PDF</small>
            </div>

            <label>
              First Name<span className="required">*</span>
            </label>
            <input
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
              required
            />

            <label>
              Last Name<span className="required">*</span>
            </label>
            <input
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
              required
            />

            <label>
              E-mail<span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
              required
            />

            <label>
              Contact Number
              <span className="required">*</span>
            </label>
            <input
              type="text"
              name="contactNumber"
              value={this.state.contactNumber}
              onChange={this.handleChange}
            />

            <label>
              Cover Letter<span className="required">*</span>
            </label>
            <textarea
              name="coverLetter"
              value={this.state.coverLetter}
              onChange={this.handleChange}
              required
            ></textarea>

            <label>
              What is your expected salary for this position?
              <span className="required">*</span>
            </label>
            <input
              type="text"
              name="expectedSalary"
              value={this.state.expectedSalary}
              onChange={this.handleChange}
              required
            />

            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="agree"
                checked={this.state.agree}
                onChange={this.handleChange}
              />
              <span>
                I agree to give the above personal data to Ambrum. Ambrum may
                use the data to evaluate, store for further processing and use
                anonymized data to train our models to improve our recruitment
                process.
              </span>
            </div>

            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </div>
      );
    }
    return null;
  }
  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({ [name]: type === "checkbox" ? checked : value });
  };

  handleFileChange = (e) => {
    this.setState({ resume: e.target.files[0] });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", this.state);
    // Submit logic here
  };
  render() {
    const { activeTab } = this.state;
    return (
      <Container className="mt-9">
        <div className="tabs-container">
          <div
            className={`tab ${activeTab === "overview" ? "active" : ""}`}
            onClick={() => this.setActiveTab("overview")}
          >
            Overview
          </div>
          <div
            className={`tab ${activeTab === "application" ? "active" : ""}`}
            onClick={() => this.setActiveTab("application")}
          >
            Application
          </div>
        </div>
        <div className="hero-text-2">Digital Marketing Executive</div>
        <div className="mt-4 my-5 d-flex">
          <div className="bg-light w-fc me-2 rounded-pill p-2">
            <i className="fa-solid fa-laptop me-1"></i>Hybrid
          </div>
          <div className="bg-light w-fc rounded-pill p-2">
            <i className="fa-solid fa-location-dot  me-1"></i>Colombo
          </div>
        </div>
        <div>{this.renderContent()}</div>
      </Container>
    );
  }
}
